// extracted by mini-css-extract-plugin
module.exports = {"logistics-explorer":"LogisticsExplorer_logistics-explorer__LVuqG"};